// Insert the magnified layer synchronously using the image the browser has
// already loaded. Waiting for a second image load can re-open the layer after
// the pointer has left the media.
function createOverlay(image) {
  const overlay = document.createElement('div');
  prepareOverlay(overlay, image.currentSrc || image.src);
  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function prepareOverlay(container, source) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${source}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(image, event, zoomRatio, overlay) {
  const container = image.getBoundingClientRect();
  if (!container.width || !container.height) return;

  const xPercent = Math.min(100, Math.max(0, ((event.clientX - container.left) / container.width) * 100));
  const yPercent = Math.min(100, Math.max(0, ((event.clientY - container.top) / container.height) * 100));

  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = `${container.width * zoomRatio}px auto`;
}

function magnify(image, zoomRatio, event) {
  const overlay = createOverlay(image);
  if (event) moveWithHover(image, event, zoomRatio, overlay);
  return overlay;
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  images.forEach((image) => {
    if (!canHover) {
      image.onclick = (event) => {
        const overlay = magnify(image, zoomRatio, event);
        overlay.onclick = () => overlay.remove();
      };
      return;
    }

    const hoverTarget = image.closest('.product__modal-opener');
    if (!hoverTarget) return;

    let activeOverlay = null;
    let hoverFrame = null;

    const hideOverlay = () => {
      if (hoverFrame) window.cancelAnimationFrame(hoverFrame);
      hoverFrame = null;
      activeOverlay?.remove();
      activeOverlay = null;
    };

    const verifyHover = () => {
      if (!activeOverlay) return;
      if (!hoverTarget.matches(':hover')) {
        hideOverlay();
        return;
      }
      hoverFrame = window.requestAnimationFrame(verifyHover);
    };

    const showOverlay = (event) => {
      hideOverlay();
      activeOverlay = magnify(image, zoomRatio, event);
      hoverFrame = window.requestAnimationFrame(verifyHover);
    };

    hoverTarget.addEventListener('pointerenter', showOverlay);
    hoverTarget.addEventListener('pointermove', (event) => {
      if (!activeOverlay) showOverlay(event);
      else moveWithHover(image, event, zoomRatio, activeOverlay);
    });
    hoverTarget.addEventListener('pointerleave', hideOverlay);
    hoverTarget.addEventListener('pointercancel', hideOverlay);
    window.addEventListener('blur', hideOverlay);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) hideOverlay();
    });
  });

  if (canHover) {
    document.querySelectorAll('.product__media-toggle.product__media-zoom-hover').forEach((toggle) => {
      toggle.setAttribute('tabindex', '-1');
      toggle.setAttribute('aria-hidden', 'true');
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    });
  }
}

enableZoomOnHover(2);
